import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/** 新建保存商品基础信息数据（#127）
 * @param {Object} data
 */
export function addProduct(data) {
  return request("".concat(BASE_URL) + "/product", METHOD.POST, data);
}

/**
 * 获取商品基础信息（#128）
 */
export function getProductDetail(id) {
  return request("".concat(BASE_URL) + "/product/detail/" + id, METHOD.GET);
}

/** 更新商品基础信息数据（#135）
 * @param {Object} data
 */
export function updateProduct(data) {
  return request("".concat(BASE_URL) + "/product", METHOD.PUT, data);
}

/**
 * 商品分类=》获取全部分类的id和name数据列表（#107）
 */
export function getClassify(data) {
  return request("".concat(BASE_URL) + "/product/category/onlyIdAndName/list", METHOD.GET, data, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

/**
 * 获取售卖单位数据列表（#118）
 */
export function getSaleunit() {
  return request("".concat(BASE_URL) + "/unit/sale/list", METHOD.GET);
}

/**
 * 获取品牌id及name数据列表（#102）
 * （1：启用  2：全部）
 */
export function getBrand(statusType) {
  return request("".concat(BASE_URL) + "/brand/onlyIdAndName/list", METHOD.GET, statusType, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

/**
 * 获取原产地id及name数据列表（#103）
 * （1：启用  2：全部）
 */
export function getSourcearea(statusType) {
  return request("".concat(BASE_URL) + "/countryOfOrign/onlyIdAndName/list", METHOD.GET, statusType, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

/**
 * 获取商品配送信息（#131）
 */
export function getLogistics(id) {
  return request("".concat(BASE_URL) + "/product/logistics/" + id, METHOD.GET);
}

/** 更新商品配送信息接口（#139）
 * @param {Object} data
 */
export function updateLogistics(data) {
  return request("".concat(BASE_URL) + "/product/logistics", METHOD.PUT, data);
}

/**
 * 获取运输方式id和name数据列表（#101）
 */
export function getTransport() {
  return request("".concat(BASE_URL) + "/transport/onlyIdAndName/list", METHOD.GET);
}

/**
 * 获取SEO信息（#133）
 */
export function getSEO(id) {
  return request("".concat(BASE_URL) + "/product/seo/" + id, METHOD.GET);
}

/** 更新商品SEO信息数据（#143）
 * @param {Object} data
 */
export function updateSEO(data) {
  return request("".concat(BASE_URL) + "/product/seo", METHOD.PUT, data);
}

/**
 * 获取发货渠道id及name数据列表（#122）
 * （1：启用  2：全部）
 */
export function getDeliveryChannel(statusType) {
  return request("".concat(BASE_URL) + "/merchantChannel/onlyIdAndName/list", METHOD.GET, statusType, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

/**
 * 查询商品列表接口（#100） 弹窗
 */
export function getProductList(data) {
  return request("".concat(BASE_URL) + "/product/list", METHOD.POST, data);
}

/**  
 * 查询商品列表接口（#343） 列表
 */
export function getProductList2(data) {
  return request("".concat(BASE_URL) + "/product/productlist", METHOD.POST, data);
}

/**
 * 获取指定商品的多规格数据（#9999）
 */
export function getProductOptions(data) {
  return request("".concat(BASE_URL) + "/product/options", METHOD.POST, data);
}

/** 批量上架商品（#105）
 * @param {Object} data
 */
export function itemupshelf(data) {
  return request("".concat(BASE_URL) + "/product/itemupshelf?productIds=" + data.productIds, METHOD.PUT);
}

/** 批量下架接口（#106）
 * @param {Object} data
 */
export function soldout(id, type) {
  return request("".concat(BASE_URL) + "/product/soldout/?productIds=" + id + "&type=" + type, METHOD.PUT);
}

/** 上架商品（#105）
 * @param {Object} data
 */
export function onShelfProductOption(data) {
  return request("".concat(BASE_URL) + "/product/onShelfProductOption?productOptionId=" + data, METHOD.PUT);
}

/** 下架和终卖接口（#336）
 * @param {Object} data
 */
export function offShelfProductOption(id, type) {
  return request("".concat(BASE_URL) + "/product/offShelfProductOption?productOptionId=" + id + "&type=" + type, METHOD.PUT);
}

/** 删除商品接口（#106）
 * @param {Object} data
 */
export function deleteProduct(data) {
  return request("".concat(BASE_URL) + "/product/delete?productIds=" + data, METHOD.DELETE);
}

/**
 * 获取运输方式id和name数据列表（#101）
 */
export function getPictureDescription(id) {
  return request("".concat(BASE_URL) + "/product/imageDesc/" + id, METHOD.GET);
}

/**
 * 更新商品图文描述信息数据（#137）
 */
export function updateProductOptions(data) {
  return request("".concat(BASE_URL) + "/product/image/desc", METHOD.PUT, data);
}

/**
 * 获取消费税率id，name及rate信息数据（#119）
 */
export function getTaxList() {
  return request("".concat(BASE_URL) + "/tax/info/list", METHOD.GET);
}

/**
 * 获取重量单位数据列表（#114）
 */
export function getUnitWeightList() {
  return request("".concat(BASE_URL) + "/unit/weight/list", METHOD.GET);
}

/**
 * 获取尺寸单位数据列表（#113）
 */
export function getUnitSizeList() {
  return request("".concat(BASE_URL) + "/unit/size/list", METHOD.GET);
}

/**
 * 获取售卖单位数据列表（#118）
 */
export function getUnitSaleList() {
  return request("".concat(BASE_URL) + "/unit/sale/list", METHOD.GET);
}

/**
 * 更新价格库存（输入框信息）（#333）
 */
export function updatePriceAndStock(data) {
  return request("".concat(BASE_URL) + "/product/updatePriceAndStock", METHOD.PUT, data);
}

/**
 * 获取价格库存数据（#338）
 */
export function getPriceAndStockInfo(id) {
  return request("".concat(BASE_URL) + "/product/priceAndStockInfo/" + id, METHOD.GET);
}

/**
 * 获取商品规格名和规格值列表信息（#339）
 */
export function getSpecList(id) {
  return request("".concat(BASE_URL) + "/product/getSpecList/" + id, METHOD.GET);
}

/**
 * 新增规格值（#332）
 */
export function addSpecValue(data) {
  return request("".concat(BASE_URL) + "/product/spec/addSpecName", METHOD.POST, data);
}

/**
 * 更新规格值（#330）
 */
export function updateSpecValue(data) {
  return request("".concat(BASE_URL) + "/product/spec/updateSpecValueName", METHOD.PUT, data);
}

/**
 * 删除规格值（#331）
 */
export function deleteSpecValue(id) {
  return request("".concat(BASE_URL) + "/product/spec/deleteSpecValue/" + id, METHOD.DELETE);
}

/**
 * 根据规格值Id获取规格值明细(#342)
 */
export function getSpecValueDetail(id) {
  return request("".concat(BASE_URL) + "/product/spec/specValueDetail/" + id, METHOD.GET);
}

/**
 * 根据规格名ID获取规格详情(#341)
 */
export function getSpecNameDetail(id) {
  return request("".concat(BASE_URL) + "/product/spec/specDetail/" + id, METHOD.GET);
}

/**
 * 更新规格名接口（#329）
 */
export function updateSpecName(data) {
  return request("".concat(BASE_URL) + "/product/spec/updateSpecName", METHOD.PUT, data);
}

/**
 * 获取商品规格明细数据（#340）
 */
export function getSpecDetailList(id) {
  return request("".concat(BASE_URL) + "/product/specDetailList/" + id, METHOD.GET);
}

/**
 * 更新规格明细表（用于多规格和单规格）（#334）
 */
export function saveSpecDetailList(data) {
  return request("".concat(BASE_URL) + "/product/specDetailList", METHOD.PUT, data);
}

// 复制商品
export function copyProduct(id) {
  return request("".concat(BASE_URL) + "/product/copy?productId=" + id, METHOD.POST);
}

// 获取运费模板
export function getFrightMode() {
  return request("".concat(BASE_URL) + "/product/freighttemplatelist", METHOD.GET);
}

//保存规格值顺序 #343
export function updateSpecSort(data) {
  return request("".concat(BASE_URL) + "/product/spec/updateSpecValueSort", METHOD.PUT, data);
}

// 根据商品编号获取商品信息
export function getContentfromProductNO(data) {
  return request("".concat(BASE_URL) + "/product/search", METHOD.GET, data);
}

// 同步商品信息
export function syncProductContent() {
  return request("".concat(BASE_URL) + "/systemSetting/syncErpProducts", METHOD.GET);
}